module.exports = __webpack_public_path__ + "static/media/group.24649102.svg";